<div
  id="standard-modal"
  role="dialog"
  aria-labelledby="standard-modalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog modal-xl">
    <div class="modal-content">
      <div class="modal-header mb-4">
        <h4 class="modal-title" id="standard-modalLabel">
          {{ (isNew ? 'shared.contactGroupEdit.add' : 'shared.contactGroupEdit.edit') | translate }} {{ 'shared.contactGroupEdit.group' | translate }}
        </h4>
        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          aria-hidden="true"
          (click)="close()"
        ></button>
      </div>

      <div class="modal-body">
        <form [formGroup]="formGroup">
          <div class="mb-3">
            <label for="name" class="form-label">{{ 'shared.contactGroupEdit.name' | translate }}</label>
            <input
              type="text"
              id="name"
              class="form-control"
              formControlName="name"
              maxlength="100"
              [placeholder]="'shared.contactGroupEdit.typePlaceholder' | translate"
            />
          </div>
        </form>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-light" (click)="close()">
          {{ 'shared.contactGroupEdit.cancel' | translate }}
        </button>

        <button type="button" class="btn btn-primary" (click)="save()">
          {{ !loading ? ((isNew ? 'shared.contactGroupEdit.save' : 'shared.contactGroupEdit.edit') | translate) : "" }}

          @if(loading) {
          <mat-spinner
            [diameter]="25"
            [color]="'accent'"
            mode="indeterminate"
          />
          }
        </button>
      </div>
    </div>
  </div>
</div>
